module.exports = __webpack_public_path__ + "static/tractor-4206153b2c58cb793bcaa0d848370168.png";